module.exports = __webpack_public_path__ + "sunsemweb/img/yj.5f83dac9.png";